import { render, staticRenderFns } from "./suspendCard.vue?vue&type=template&id=03d81be9&scoped=true&"
import script from "./suspendCard.vue?vue&type=script&lang=js&"
export * from "./suspendCard.vue?vue&type=script&lang=js&"
import style0 from "./suspendCard.vue?vue&type=style&index=0&id=03d81be9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d81be9",
  null
  
)

component.options.__file = "suspendCard.vue"
export default component.exports